module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "nav",
    class: {
      'm-nav': true, 'm-nav--fixed': _vm.isOutofView
    }
  }, [_c('nav', [_c('div', {
    class: {
      active: _vm.activeId === _vm.allId, 'nav-item': true
    }
  }, [_c('span', {
    staticClass: "fz15",
    on: {
      "click": function($event) {
        return _vm.changeActive(_vm.allId)
      }
    }
  }, [_vm._v("全部")])]), _vm._v(" "), _c('div', {
    class: {
      active: _vm.activeId === _vm.eliteId, 'nav-item': true
    }
  }, [_c('span', {
    staticClass: "fz15",
    on: {
      "click": function($event) {
        return _vm.changeActive(_vm.eliteId)
      }
    }
  }, [_vm._v("精华")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-08feda23"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/content/nav.vue
// module id = 199
// module chunks = 1